import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c866835"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-content" }

import { computed, ref } from 'vue'
import { ROOM_SPACE_URL } from '@/composables/api'
import useAuth from '@/composables/api/useAuth'
import { useI18n } from 'vue-i18n'
import { EngineChangeSocketEmit } from '@/types/interfaces/room.interface'
import { Engine } from '@/types/enums/room.enum'
import useSocketEvent from '@/composables/room/useSocketEvent'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotifyVideoEngineChangePopup',
  props: {
  isMainEngine: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18n()
const { getAccessInfo } = useAuth()
const { socket } = useSocketEvent()
const isOpenedPopup = ref(false)
const link = ref('')
const moveToContent = computed(() =>
  props.isMainEngine ? t('room-changed.content.second-room') : t('room-changed.content.main-room'),
)

const joinText = computed(() =>
  props.isMainEngine ? t('room-changed.join.second-room') : t('room-changed.join.main-room'),
)
const join = () => {
  isOpenedPopup.value = false
  window.location.href = link.value
  socket?.disconnect()
}

socket.on('engineChanged', (data: EngineChangeSocketEmit) => {
  const { queryToken } = getAccessInfo()
  const { currentEngine, version } = data
  isOpenedPopup.value = true
  if (currentEngine === Engine.TOKBOX || version === 'space5') {
    link.value = `${ROOM_SPACE_URL}/join?token=${queryToken}&tiger`
  } else {
    link.value = window.location.href
  }
})
socket.on('engineChangedToWhereby', () => {
  isOpenedPopup.value = true
  link.value = window.location.href
})

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Room changed",
    open: isOpenedPopup.value,
    "can-close": false,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (isOpenedPopup.value = false))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary text-base w-full",
        onClick: join
      }, _toDisplayString(joinText.value), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(moveToContent.value), 1)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})